// extracted by mini-css-extract-plugin
export var form = "PageEmailForm-module--form--3_Yi7";
export var submitContainer = "PageEmailForm-module--submitContainer--1Ja6b";
export var submit = "PageEmailForm-module--submit--18fjj";